import transporter from "@sendgrid/mail";
import { f as fail } from "../../../chunks/index.js";
import "dotenv/config";
transporter.setApiKey("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");
const actions = {
  submit: async ({ request }) => {
    const formData = await request.formData();
    const name = String(formData.get("name"));
    const email = String(formData.get("email"));
    const country = String(formData.get("country"));
    const message = String(formData.get("message"));
    const errors = {};
    const alphaRegex = /^[ a-zA-Z\-\']+$/;
    const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!name || typeof name !== "string") {
      errors.name = "Name Required";
    } else if (!alphaRegex.test(name)) {
      errors.name = "Letters Only!";
    }
    if (!email || typeof email !== "string") {
      errors.email = "Email Required";
    } else if (!emailRegex.test(email)) {
      errors.email = "Email Not Valid";
    }
    if (!message || typeof message !== "string") {
      errors.message = "Message Required";
    }
    if (Object.keys(errors).length > 0) {
      const data = {
        data: Object.fromEntries(formData),
        errors
      };
      return fail(400, data);
    }
    const emailPayload = {
      to: "aj@finalfrequency.media",
      from: "dev@firstlandings.com",
      subject: "FirstLandings.com Contact Form Submission",
      html: `
                <strong>Name:</strong>
                <br>
                ${name}
                <br><br>
                <strong>Email:</strong>
                <br>
                ${email}
                <br><br>
                <strong>Country:</strong>
                <br>
                ${country}
                <br><br>
                <strong>Message:</strong>
                <br>
                ${message}
                `
    };
    transporter.send(emailPayload).then(() => {
      return { success: true };
    }).catch((error) => {
      return fail(500, error.response.body);
    });
  }
};
export {
  actions
};
